module.exports = __webpack_public_path__ + "img/loader.87b52a3d.svg";